"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../../../utils");
var utils_2 = require("../utils");
var hooks_1 = require("../hooks");
var consts_1 = require("../consts");
var styles_1 = require("../SharedStyles/styles");
var styles_2 = require("../LinkListMenu/styles");
var MenuItem_1 = __importDefault(require("../MenuItem"));
var SubMenuItem_1 = __importDefault(require("../SubMenuItem"));
var styles_3 = require("./styles");
var SelectorList = function (_a) {
    var label = _a.label, icon = _a.icon, subItems = _a.subItems, onChange = _a.onChange, activeItemId = _a.activeItemId, testId = _a.testId, expandedMenu = _a.expandedMenu, setExpandedMenu = _a.setExpandedMenu, id = _a.id, trailingIcon = _a.trailingIcon, isIndependentExpanding = _a.isIndependentExpanding, isClosingOnClickOutside = _a.isClosingOnClickOutside;
    var _b = (0, hooks_1.useSidebarState)(), isSidebarOpen = _b.isSidebarOpen, isBusinessSubmenuOpen = _b.isBusinessSubmenuOpen, setIsSidebarOpen = _b.setIsSidebarOpen;
    var _c = (0, react_1.useState)(isBusinessSubmenuOpen ? 'account-selector' : null), isLocalExpanded = _c[0], setIsLocalExpanded = _c[1];
    var isMenuExpanded = isIndependentExpanding ? !!isLocalExpanded : expandedMenu === id;
    var setExpandedState = isIndependentExpanding ? setIsLocalExpanded : setExpandedMenu;
    var _d = (0, react_1.useState)(false), isPopupOpen = _d[0], setIsPopupOpen = _d[1];
    var toggleExpanded = function () {
        if (isSidebarOpen) {
            if (!isMenuExpanded) {
                localStorage.setItem('isBusinessSubmenuOpen', JSON.stringify(true));
                var customEvent = new CustomEvent(consts_1.SIDEBAR_BUSINESS_SUBMENU_EVENT_NAME, { detail: { isOpen: true } });
                window.dispatchEvent(customEvent);
                setExpandedState(id);
            }
            else {
                localStorage.setItem('isBusinessSubmenuOpen', JSON.stringify(false));
                var customEvent = new CustomEvent(consts_1.SIDEBAR_BUSINESS_SUBMENU_EVENT_NAME, { detail: { isOpen: false } });
                window.dispatchEvent(customEvent);
                setExpandedState(null);
            }
        }
        else {
            setIsPopupOpen(function (prev) { return !prev; });
        }
    };
    var handleSelectAccount = function (id) {
        var performBusinessChange = function () {
            toggleExpanded();
            if (window.innerWidth < 768) {
                localStorage.setItem('isSidebarOpen', JSON.stringify(false));
                setIsSidebarOpen(false);
                var customEvent = new CustomEvent(consts_1.SIDEBAR_STATE_CHANGE_EVENT_NAME, { detail: { newState: false } });
                window.dispatchEvent(customEvent);
            }
            onChange(id);
        };
        if (window.location.pathname.includes(consts_1.ROUTE_ADD_MACHINE)) {
            window.dispatchEvent(new Event(consts_1.SIDEBAR_BUSINESS_CHANGE_ATTEMPT_EVENT));
            var handleConfirm_1 = function () {
                performBusinessChange();
                window.removeEventListener(consts_1.SIDEBAR_BUSINESS_CHANGE_CONFIRMED_EVENT, handleConfirm_1);
                window.removeEventListener(consts_1.SIDEBAR_BUSINESS_CHANGE_CANCELLED_EVENT, handleCancel_1);
            };
            var handleCancel_1 = function () {
                window.removeEventListener(consts_1.SIDEBAR_BUSINESS_CHANGE_CONFIRMED_EVENT, handleConfirm_1);
                window.removeEventListener(consts_1.SIDEBAR_BUSINESS_CHANGE_CANCELLED_EVENT, handleCancel_1);
            };
            window.addEventListener(consts_1.SIDEBAR_BUSINESS_CHANGE_CONFIRMED_EVENT, handleConfirm_1);
            window.addEventListener(consts_1.SIDEBAR_BUSINESS_CHANGE_CANCELLED_EVENT, handleCancel_1);
        }
        else {
            performBusinessChange();
        }
    };
    var menuItemRef = (0, react_1.useRef)(null);
    var menuDropdownRef = (0, react_1.useRef)(null);
    var menuPopupRef = (0, react_1.useRef)(null);
    var popupPosition = (0, utils_2.getPopupPosition)(menuItemRef, 'bottom');
    var onClickOutside = (0, react_1.useCallback)(function () {
        if (isMenuExpanded && isClosingOnClickOutside) {
            localStorage.setItem('isBusinessSubmenuOpen', JSON.stringify(false));
            var customEvent = new CustomEvent(consts_1.SIDEBAR_BUSINESS_SUBMENU_EVENT_NAME, { detail: { isOpen: false } });
            window.dispatchEvent(customEvent);
            setExpandedState(null);
        }
        setIsPopupOpen(false);
    }, [isSidebarOpen, isMenuExpanded, isClosingOnClickOutside]);
    (0, utils_1.useOnClickOutside)([menuItemRef, menuDropdownRef, menuPopupRef], onClickOutside);
    var itemList = subItems.map(function (item) { return ((0, jsx_runtime_1.jsx)(SubMenuItem_1.default, { withoutRoute: true, onClickWithoutRouteMenu: handleSelectAccount, isOpen: isSidebarOpen, label: item.label, activeItem: item.id === activeItemId, id: item.id, testId: "".concat(testId, "-").concat(item.id || item.testId), tabIndex: isMenuExpanded || isPopupOpen ? 0 : -1 }, item.id)); });
    return ((0, jsx_runtime_1.jsx)(styles_3.Container, { children: subItems.length > 1 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styles_2.InnerContainer, { children: (0, jsx_runtime_1.jsx)(MenuItem_1.default, { label: label, icon: icon, onClick: toggleExpanded, isExpandable: true, forwardRef: menuItemRef, testId: testId, isMenuOpen: isMenuExpanded || isPopupOpen, trailingIcon: trailingIcon, autoFocusId: "".concat(testId, "-").concat(subItems[0].id || subItems[0].testId) }) }), (0, jsx_runtime_1.jsx)(styles_1.ExpandableListContainer, __assign({ className: (0, classnames_1.default)({ open: isMenuExpanded && isSidebarOpen }), ref: menuDropdownRef }, { children: itemList })), (0, jsx_runtime_1.jsx)(styles_1.ClosedPopupContainer, __assign({ popupBottomPosition: popupPosition, className: (0, classnames_1.default)({ visible: isPopupOpen && !isSidebarOpen }), ref: menuPopupRef }, { children: itemList }))] })) : ((0, jsx_runtime_1.jsx)(MenuItem_1.default, { label: label, icon: icon, testId: testId, trailingIcon: trailingIcon })) }));
};
exports.default = SelectorList;
